/**
 * Directive for drawing tooltips
 */
define(function(require, exports) {
    'use strict';

    // @ngInject
    exports.metTooltip = function (metTooltipFactory) {
        return {
            restrict: 'E',
            scope: {
                key: '@',
                category: '@',
                placement: '@',
                inline: '@',
                showTitle: '@'
            },
            link: function (scope, element) {

                scope.flags = {
                    showMore: false,
                    hasMore: false
                };

                scope.allowEdit = b$.portal.loggedInUserRole === 'admin';
                scope.goTo = function () {
                    if (scope.allowEdit) {
                        window.open('/portalserver/cxp-manager/shared-content//_/tooltips/' + scope.tooltip.category + '/' + scope.tooltip.key + '?view=content', '_blank');
                    }
                };

                function retrieveTooltip() {
                    scope.tooltip = metTooltipFactory.getTooltip(scope.category, scope.key, scope.placement, scope.inline, scope.icon);
                    if (scope.tooltip) {
                        if (!scope.tooltip.inline) {
                            var onMouseOver = function () {
                                scope.showTooltip = true;
                            };

                            var onMouseOut = function () {
                                scope.showTooltip = false;
                            };
                            element.on('mouseenter', onMouseOver);
                            element.on('mouseleave', onMouseOut);
                        } else {
                            scope.flags.hasMore = scope.tooltip.expandable || false;
                            scope.tooltipExtention = scope.tooltip.expandableContents || '';
                            scope.title = scope.tooltip.title || '';
                            scope.toggleView = function () {
                                scope.flags.showMore = !scope.flags.showMore;
                            };
                        }
                    }
                }

                retrieveTooltip();


                if (scope.key) {
                    scope.$watch('key', function () {
                        retrieveTooltip();
                    });
                }

            },
            template: [
                '<span>',
                '    <a ng-if="!tooltip.inline"  href="javascript:void(0)" tabindex="-1" tooltip-trigger tooltip-placement="{{tooltip.placement}}" tooltip-html-unsafe="{{tooltip.contents}}" tooltip-popup-delay="100">',
                '        <i data-ng-click="goTo()" class="fa fa-{{tooltip.icon}}"></i>',
                '    </a>',
                '    <div ng-if="tooltip.inline" class="mb-tp">',
                '        <i ng-if="tooltip.icon" data-ng-click="goTo()"  class="fa fa-{{tooltip.icon}} tooltip-inline-icon"></i>',
                '        <span class="title" ng-if="tooltip.showTitle" ng-bind-html="tooltip.title"></span>',
                '        <span ng-bind-html="tooltip.contents"></span>',
                '        <div ng-if="flags.hasMore">',
                '            <span ng-bind-html="tooltip.expandableContents" ng-show="flags.showMore"></span>',
                '            <div class="expandable-switcher">',
                '                <a href="javascript:void(0)" tabindex="-1" ng-click="toggleView()" class="pull-left">{{flags.showMore ? \'-\' : \'+\'}}</a>',
                '                <hr/>',
                '            </div>',
                '        </div>',
                '    </div>',
                '</span>'
            ].join('')
        };
    };

    // @ngInject
    exports.metWrappingTooltip = function (metTooltipFactory) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            link: function (scope, element, attrs) {
                scope.category = attrs.category;
                scope.key = attrs.key;
                scope.showTooltip = false;
                scope.placement = attrs.placement || 'top';


                scope.tooltip = metTooltipFactory.getTooltip(scope.category, scope.key, scope.placement, scope.inline, scope.icon);

                if (scope.tooltip) {
                    var onMouseOver = function () {
                        scope.showTooltip = true;
                    };

                    var onMouseOut = function () {
                        scope.showTooltip = false;
                    };
                    element.on('mouseenter', onMouseOver);
                    element.on('mouseleave', onMouseOut);
                }

            },
            template: '<div style="display: inline-block;"  tooltip-placement="{{tooltip.placement}}" tooltip-html-unsafe="{{tooltip.contents}}" tooltip-popup-delay="100" ng-transclude></div>'

        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metTooltip/metTooltip.js